module.exports = __webpack_public_path__ + "img/sen_mag.0bd9aaf1.png";